import apiRequest from '@app/utils/apiRequest';

// export const requestCandidateGroups = (params) => apiRequest.get(`/candidate/candidate-group/list`, {params: params});

export const requestSendEmail = (data) =>
    apiRequest.post(`/mail/send`, data);

// export const requestDeleteGroup = (data) =>
//     apiRequest.delete(`/candidate/candidate-group/delete`, {data: data});
//
// export const requestRemoveCandidateOutGroup = (data) =>
//     apiRequest.post(`/candidate/candidate-group/remove-candidate`, data);
//
// export const requestAddCandidateIntoGroup = (data) =>
//     apiRequest.post(`/candidate/candidate-group/add-candidate`, data);

export const requestSendCampaign = (data) =>
    apiRequest.post(`/mail/ses/campaign/send/`, data);

export const requestListCampaigns = (showAll = false) =>
    apiRequest.get(showAll ? `/mail/ses/campaign/list/?show_all=true` : `/mail/ses/campaign/list/`);

export const requestListCampaignRecipients = (campaignId, page = 1, failedOnly = false) =>
    apiRequest.get(`/mail/ses/campaign/${campaignId}/recipients/`, {
        params: failedOnly ? {page, failed_only: true} : {page},
    });

export const requestRetryCampaign = (campaignId, data) =>
    apiRequest.post(`/mail/ses/campaign/${campaignId}/retry/`, data);

export const requestListVerifiedSenderIdentities = () =>
    apiRequest.get(`/mail/ses/verified-identities/`);
